module.exports = __webpack_public_path__ + "static/media/totalPnts_50000.ae25ad10.png";